import { render, staticRenderFns } from "./TodoOrderDetail.vue?vue&type=template&id=2ee587e5&scoped=true&"
import script from "./TodoOrderDetail.vue?vue&type=script&lang=js&"
export * from "./TodoOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./TodoOrderDetail.vue?vue&type=style&index=0&id=2ee587e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee587e5",
  null
  
)

export default component.exports